document.addEventListener('DOMContentLoaded', () => {
  const mqDesktop = window.matchMedia('(min-width: 1024px)');
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const isInteractiveElement = (target) => {
    return !!target.closest(`
      input,
      textarea,
      select,
      option,
      button,
      a,
      label,
      iframe,
      [contenteditable="true"],
      .klaviyo-form,
      .klaviyo-form *
    `);
  };

  document.querySelectorAll('.swipe-desktop').forEach((container) => {
    const dragTarget = container.querySelector('.swipe-desktop__inner') || container;
    const rail = container.querySelector('.swipe-desktop__inner');
    const btnPrev = container.querySelector('.swipe-desktop__btn--prev');
    const btnNext = container.querySelector('.swipe-desktop__btn--next');

    let isDown = false;
    let startX = 0;
    let startLeft = 0;
    let moved = 0;

    let lastX = 0;
    let lastT = 0;
    let velocity = 0;
    let rafId = null;

    let step = 0;
    let prevBehaviorTimer = null;

    const stopRAF = () => {
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    };

    container._stopInertia = stopRAF;

    const restoreScrollBehavior = () => {
      if (prevBehaviorTimer) {
        clearTimeout(prevBehaviorTimer);
        prevBehaviorTimer = null;
      }
      container.style.scrollBehavior = container.dataset.prevBehavior || '';
    };

    const onDown = (e) => {
      if (!mqDesktop.matches || e.button !== 0) return;
      if (isInteractiveElement(e.target)) return;

      isDown = true;
      moved = 0;
      stopRAF();

      container.classList.add('is-dragging');

      startX = e.pageX;
      startLeft = container.scrollLeft;

      lastX = e.pageX;
      lastT = performance.now();
      velocity = 0;

      container.dataset.prevBehavior = container.style.scrollBehavior || '';
      container.style.scrollBehavior = 'auto';

      e.preventDefault();
    };

    const onMove = (e) => {
      if (!isDown) return;

      const now = performance.now();
      const dx = e.pageX - startX;

      moved = Math.max(moved, Math.abs(dx));
      container.scrollLeft = startLeft - dx;

      const dt = now - lastT || 16;
      const instV = (e.pageX - lastX) / dt;
      velocity = velocity * 0.8 + instV * 0.2;

      lastX = e.pageX;
      lastT = now;
    };

    const animateInertia = () => {
      const maxLeft = Math.max(0, container.scrollWidth - container.clientWidth);
      const friction = 0.94;
      const stopThreshold = 0.02;

      let nextLeft = container.scrollLeft - velocity * 16;

      // Clamp strict aux bornes
      if (nextLeft <= 0) {
        container.scrollLeft = 0;
        velocity = 0;
      } else if (nextLeft >= maxLeft) {
        container.scrollLeft = maxLeft;
        velocity = 0;
      } else {
        container.scrollLeft = nextLeft;
        velocity *= friction;
      }

      if (Math.abs(velocity) < stopThreshold || prefersReduced.matches) {
        rafId = null;
        restoreScrollBehavior();
        container.classList.remove('is-dragging');
        updateDisabled();
        return;
      }

      rafId = requestAnimationFrame(animateInertia);
    };

    const onUp = () => {
      if (!isDown) return;
      isDown = false;

      if (moved > 5) {
        const stopClick = (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
        };

        dragTarget.addEventListener('click', stopClick, true);
        setTimeout(() => {
          dragTarget.removeEventListener('click', stopClick, true);
        }, 0);
      }

      const minKick = 0.05;
      if (Math.abs(velocity) >= minKick && !prefersReduced.matches) {
        stopRAF();
        rafId = requestAnimationFrame(animateInertia);
      } else {
        restoreScrollBehavior();
        container.classList.remove('is-dragging');
        updateDisabled();
      }
    };

    const computeStep = () => {
      if (!rail) return;

      const first = rail.children[0];
      const itemW = first ? first.getBoundingClientRect().width : rail.clientWidth;

      const styles = getComputedStyle(rail);
      const gap =
        parseFloat(styles.columnGap) ||
        parseFloat(styles.gap) ||
        0;

      step = Math.round(itemW + gap);
    };

    const scrollByStep = (dir = 1) => {
      if (!mqDesktop.matches) return;

      stopRAF();
      container.classList.remove('is-dragging');

      const prevBehavior = container.style.scrollBehavior;
      container.style.scrollBehavior = 'smooth';
      container.scrollBy({ left: dir * step, top: 0, behavior: 'smooth' });

      if (prevBehaviorTimer) clearTimeout(prevBehaviorTimer);
      prevBehaviorTimer = window.setTimeout(() => {
        container.style.scrollBehavior = prevBehavior || '';
        updateDisabled();
      }, 400);
    };

    const updateDisabled = () => {
      if (!btnPrev || !btnNext) return;

      const maxLeft = Math.max(0, container.scrollWidth - container.clientWidth - 1);
      btnPrev.disabled = container.scrollLeft <= 0;
      btnNext.disabled = container.scrollLeft >= maxLeft;
    };

    dragTarget.addEventListener('mousedown', onDown);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);

    if (btnNext) {
      btnNext.addEventListener('click', () => scrollByStep(1));
    }

    if (btnPrev) {
      btnPrev.addEventListener('click', () => scrollByStep(-1));
    }

    container.addEventListener('scroll', updateDisabled, { passive: true });

    if (rail) {
      computeStep();

      const ro = new ResizeObserver(() => {
        computeStep();
        updateDisabled();
      });

      ro.observe(rail);
    }

    updateDisabled();
  });
});